<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">员工报送</li>
      <li
        v-if="state.selectIds?.length > 0"
        style="display: flex; align-items: flex-end"
      >
        已选择<strong style="color: #1e90ff; margin: 0 5px">{{
          state.selectIds?.length
        }}</strong
        >条数据
        <el-button
          type="danger"
          :icon="Delete"
          link
          @click="state.selectIds = []"
          style="margin-right: 20px"
        >
          清空已选
        </el-button>
      </li>

      <el-button
        type="primary"
        :icon="Edit"
        :disabled="!state.selectIds?.length > 0"
        link
        @click="state.showEdits = true"
        v-if="$judge_auth('763')"
      >
        批量编辑
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onDeclare"
        v-if="$judge_auth('11')"
      >
        报送
      </el-button>
      <!-- <el-button
        type="warning"
        :icon="SwitchButton"
        link
        @click="onStop"
        v-if="$judge_auth('12')"
        >停止报税</el-button
      > -->
      <el-button
        type="danger"
        :icon="Close"
        link
        @click="onCancel"
        v-if="$judge_auth('13')"
      >
        作废
      </el-button>
      <el-button
        type="warning"
        :icon="RefreshRight"
        link
        @click="onUpdate"
        v-if="$judge_auth('14')"
      >
        更新身份验证状态
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、电话、身份证号、银行卡号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <c_statusselect
        v-model="state.params.declare_status"
        arrName="employeedeclare_declare_status"
        placeholder="报送状态"
        width="120"
        @change="onLoad"
        :key="state.key"
      ></c_statusselect>
      <c_statusselect
        v-model="state.params.verify_status"
        arrName="employeedeclare_verify_status"
        @change="onLoad"
        placeholder="身份验证状态"
        width="140"
        :key="state.key"
      ></c_statusselect>
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-select
          v-model="state.params.status"
          placeholder="在职状态"
          style="width: 100px"
        >
          <el-option label="在职" :value="1" />
          <el-option label="离职" :value="0" />
        </el-select>
      </el-config-provider>
      <el-date-picker
        v-model="state.rzDates"
        type="daterange"
        range-separator="至"
        start-placeholder="入职日期"
        end-placeholder="入职日期"
        value-format="YYYY-MM-DD"
        style="width: 300px; flex-grow: 0"
        @clear="
          delete state.rzDates;
          delete state.params.entry_time;
        "
      />
      <el-date-picker
        v-model="state.lzDates"
        type="daterange"
        range-separator="至"
        start-placeholder="离职日期"
        end-placeholder="离职日期"
        value-format="YYYY-MM-DD"
        style="width: 300px; flex-grow: 0"
        @clear="
          delete state.lzDates;
          delete state.params.resignation_time;
        "
      />
      <el-date-picker
        v-model="state.params.skssq"
        type="month"
        placeholder="税款所属期"
        value-format="YYYYMM"
        format="YYYY年M月"
        style="width: 140px"
      />
      <el-checkbox
        v-model="state.params.is_need_declare"
        :true-value="1"
        label="需重新报送"
        size="large"
        @change="onLoad"
        :key="state.key"
      />
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column width="55" fixed @click.stop="">
            <template #header>
              <el-checkbox :value="-1" @change="onSelect($event, -1)" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onRowClick(row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="name"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="100"
            fixed
          />
          <el-table-column
            prop="phone"
            label="手机号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.phone)"
              >
                {{ row.phone }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            prop="idcard"
            label="证件号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="180"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.idcard)"
              >
                {{ row.idcard }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="报送状态"
            prop="declare_status"
            sortable="declare_status"
            width="140"
            align="center"
          >
            <template #default="{ row }">
              <el-tooltip
                effect="dark"
                content="员工信息变更，可重新报送！"
                v-if="row.declare_status == 1 && row.is_need_declare == 1"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    line-height: 14px;
                  "
                >
                  <div
                    style="
                      width: fit-content;
                      color: #ffa500;
                      font-size: 14px;
                      margin-right: 3px;
                    "
                  >
                    已报送
                  </div>
                  <el-icon><QuestionFilled /></el-icon>
                </div>
              </el-tooltip>
              <template v-else>
                <el-tooltip
                  effect="dark"
                  :content="row.declare_msg"
                  v-if="row.declare_msg"
                >
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="employeedeclare_declare_status"
                      :value="row.declare_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="人员状态"
            :formatter="$tab_TextFormat"
            align="center"
            width="100"
          >
            <template #default="{ row }">
              <ul :style="{ color: row.status == 0 ? '#f00' : '#1e90ff' }">
                {{
                  row.status == 0 ? "离职" : "在职"
                }}
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="80">
            <template #default="{ row }">
              <text v-if="row.sex == '男'" style="color: #1e90ff">男</text>
              <text v-else-if="row.sex == '女'" style="color: #f00">女</text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="idtype"
            label="证件类型"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :formatter="$tab_TextFormat"
            min-width="240"
          >
            <template #default="{ row }">
              <div
                :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                :style="{
                  '--dynamic-color':
                    row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                }"
                class="withholding-badge"
              >
                {{ row.withholding_agent_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="统一社会信用代码" width="220">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                @click.stop="$onCopy(row.unified_social_credit_identifier)"
                v-if="row.unified_social_credit_identifier"
              >
                {{ row.unified_social_credit_identifier }}
              </text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="property"
            label="属性"
            :formatter="
              (row) =>
                $statusFormat({
                  Text: row.property == 0 ? '雇员' : '其他',
                  Color: row.property == 0 ? '#1e90ff' : '#ffa500',
                })
            "
            width="80"
          />
          <el-table-column
            prop="skssq"
            label="税款所属期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="entry_time"
            label="入职日期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="resignation_time"
            label="离职日期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="name"
            label="收款信息"
            :formatter="
              (row) =>
                $tab_GroupFormat(row.opening_bank || '-', row.bank_account)
            "
            min-width="200"
          >
            <template #default="{ row }">
              <div style="display: flex; align-items: center; width: 100%">
                <el-tag
                  v-if="row.diff_bank_status != 0"
                  effect="dark"
                  size="small"
                  :type="row.diff_bank_status == 1 ? 'warning' : 'danger'"
                  :title="
                    row.diff_bank_status == 1
                      ? '异卡发放审核中'
                      : '异卡审核已驳回'
                  "
                  style="cursor: pointer; margin-right: 5px"
                >
                  {{ row.diff_bank_status == 1 ? "审" : "驳" }}
                </el-tag>
                <div
                  style="flex: 1; overflow: hidden"
                  v-html="
                    $tab_BuildGroup(row.opening_bank || '-', row.bank_account)
                  "
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="declare_time"
            label="报送时间"
            :formatter="$tab_TextFormat"
            width="180"
          />
          <el-table-column
            prop="verify_status_name"
            label="身份验证状态"
            :formatter="$tab_TextFormat"
            width="140"
          />
          <el-table-column
            prop="verify_msg"
            label="原因"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            v-if="$judge_auth('11')"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Upload"
                @click.stop="onDeclareSingle(row)"
                :disabled="row.declare_status == -1"
                :title="row.id"
              >
                报送
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showEdits"
        title="批量编辑"
        @close="state.showEdits = false"
      >
        <c_EmployeeDeclareEdits
          :ids="state.selectIds.filter((w) => w != -1)"
        ></c_EmployeeDeclareEdits>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  employeedeclare_list,
  employeedeclare_declare,
  employeedeclare_cancel,
  employeedeclare_stoptax,
  employeedeclare_updatestatus,
} from "@/http/employeedeclare";
import {
  data_withholdingagent_select,
  data_customer_select,
} from "@/http/data";
import { ElMessage, ElMessageBox } from "element-plus";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
  };
}
export default {
  setup() {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      selectIds: [],
      withholding_agent_arr: [],
    });
    onMounted(() => {
      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      if (state.rzDates?.length > 0)
        state.params.entry_time = state.rzDates.join(" - ");
      else delete state.params.entry_time;

      if (state.lzDates?.length > 0)
        state.params.resignation_time = state.lzDates.join(" - ");
      else delete state.params.resignation_time;

      employeedeclare_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          state.selectIds = state.selectIds.filter((w) => w != -1);
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholdingagent_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.key = Math.random();
      delete state.withholding_agent_arr;
      delete state.lzDates;
      delete state.rzDates;
      onLoad();
    };

    const onSelect = (checked, item) => {
      if (item == -1) {
        if (checked) {
          state.selectIds = [
            ...state.selectIds,
            ...state.tableData
              .filter(
                (w) =>
                  w.collected_status != 2 && !state.selectIds.includes(w.id)
              )
              .map((m) => m.id),
          ];
        } else {
          state.selectIds = state.selectIds.filter(
            (w) => !state.tableData.map((m) => m.id).includes(w)
          );
        }
      }
    };

    const onRowClick = (item) => {
      if (state.selectIds?.includes(item.id)) {
        state.selectIds = state.selectIds.filter((w) => w != item.id);
      } else state.selectIds.push(item.id);
    };

    const onDeclareSingle = (row) => {
      ElMessageBox.confirm(
        `您确定对扣缴义务人(<strong style='color:#f00'>${row.withholding_agent_name}</strong>)下的员工(<strong style='color:#080'>${row.name}</strong>)提交<strong style='color:#ffa500'>报送</strong>吗？`,
        "报送提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定报送",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        employeedeclare_declare([row.id]).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    //报送
    const onDeclare = () => {
      const ids = state.selectIds.filter((w) => w != -1) || [];

      if (ids.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要报送的数据",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${ids.length}</strong>条数据，是否立即<strong style='color:#ffa500'>报送</strong>？`,
        "报送提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定报送",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        employeedeclare_declare(ids).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    const onCancel = () => {
      const ids = state.selectIds.filter((w) => w != -1) || [];

      if (ids.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要作废的数据",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${ids.length}</strong>条数据，是否立即<strong style='color:#ffa500'>作废</strong>？`,
        "作废提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定作废",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        employeedeclare_cancel(ids.join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    const onStop = () => {
      const ids = state.selectIds.filter((w) => w != -1) || [];

      if (ids.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要停止报送的数据",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${ids.length}</strong>条数据，是否立即<strong style='color:#ffa500'>停止报送</strong>？`,
        "停止报送提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定停止",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        employeedeclare_stoptax(ids).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    const onUpdate = () => {
      const ids = state.selectIds.filter((w) => w != -1) || [];

      if (ids.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要更新状态的数据",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${ids.length}</strong>条数据，是否立即<strong style='color:#ffa500'>更新身份验证状态</strong>？`,
        "更新身份验证状态提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定更新",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        employeedeclare_updatestatus(ids).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onDeclareSingle,
      onDeclare,
      onCancel,
      onStop,
      onRowClick,
      onUpdate,
      onSelect,
    };
  },
};
</script>
<style scoped></style>
